import {memo} from 'react';

import ContactUsFormSection from './ContactUsFormSection';
import ContactUsInfoPage from './ContactUsInfoPage';

type ContactUsPageContentProps = {
  experimentVariation: string;
};

const ContactUsPageContent: React.FC<ContactUsPageContentProps> = ({experimentVariation}) => {
  return (
    <>
      {/* Hero/Header Section */}
      <div className="bg-gradient-to-br from-blueberry-50 to-white py-16">
        <div className="mx-auto max-w-6xl px-6">
          <ContactUsInfoPage experimentVariation={experimentVariation} />
        </div>
      </div>

      {/* Form Section */}
      <div className="bg-gray-50 py-16">
        <div className="mx-auto max-w-6xl px-6">
          <ContactUsFormSection variant="page" />
        </div>
      </div>
    </>
  );
};

export default memo(ContactUsPageContent);
